import e from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, E = ({ size: t = 16, useVw: n, useRem: o, color: l, withColor: c, removeClassName: a, disableSSR: m, style: r, ...p }) => {
  const x = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-Ton", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), className: a ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: a ? "" : "32px-Ton"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: a ? "" : "normal",
        fill: c ? i(l, 0, "#262933") : "#262933",
        datafollowfill: c ? i(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M5.4 16c0-5.854 4.746-10.6 10.6-10.6 5.854 0 10.6 4.746 10.6 10.6a10.563 10.563 0 0 1-1.555 5.53.9.9 0 0 0 1.535.94A12.352 12.352 0 0 0 28.4 16c0-6.848-5.552-12.4-12.4-12.4C9.152 3.6 3.6 9.152 3.6 16c0 6.848 5.552 12.4 12.4 12.4 2.37 0 4.586-.665 6.47-1.82a.9.9 0 0 0-.94-1.535A10.547 10.547 0 0 1 16 26.6c-5.854 0-10.6-4.746-10.6-10.6Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M11.751 10.382h8.499c1.561 0 2.551 1.687 1.766 3.047l-5.245 9.09a.89.89 0 0 1-1.542 0l-5.245-9.09c-.786-1.362.204-3.047 1.767-3.047Zm3.472 9.41v-7.858H11.75a.481.481 0 0 0-.424.72l2.756 4.929 1.141 2.208Zm2.693-2.208 2.755-4.931a.481.481 0 0 0-.424-.72h-3.473v7.86l1.142-2.209Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = E;
export {
  s as default
};
